export const polygonize = (points: number[]): [number, number][] => {
	if (!points) {
		return [];
	}
	const result: [number, number][] = [];
	for (let i = 0; i < points.length; i += 2) {
		result.push([points[i], points[i + 1]]);
	}

	return result;
};
